export default `<svg 
  xmlns="http://www.w3.org/2000/svg" 
  width="18" 
  height="18" 
  viewBox="0 0 1127 1024"
>
  <path 
    d="M813.183 0.001c-69.289 0-132.274 26.991-179.062 71.984-1.808 1.808-476.907 476.005-476.907 476.005-5.396 5.396-8.995 11.695-10.793 18.901l-93.581 408.52c-2.714 13.504 0.903 26.991 10.793 36.896 7.206 7.206 17.095 11.695 27.89 11.695 2.714 0 6.302 0 8.995-0.903l407.621-94.482c7.206-1.808 13.504-5.396 18.901-10.793l470.607-470.607c0 0 0 0 0 0 47.692-47.692 77.387-112.479 77.387-184.464-0.903-145.769-117.875-262.75-261.851-262.75zM478.447 853.032l-239.353 55.788-73.783-73.783 54.888-240.253 1.808-1.808c18.901 1.808 36.896 8.995 51.29 23.392 18.901 18.901 26.096 44.092 22.491 68.385 24.298-3.59 50.391 3.59 68.385 22.491 18.901 18.901 26.096 44.092 22.491 68.385 24.298-3.59 50.391 3.59 68.385 22.491 14.401 14.401 22.491 33.295 23.392 53.090v1.808z"
  ></path>
</svg>`;
